module.exports = __webpack_public_path__ + "img/four3Orange.611cd7d5.jpg";